import type { PropsWithChildren } from 'react';
import { useEffect, useReducer } from 'react';
import { FormContext, WidgetContext } from './contexts';
import {
  createFormInitialState,
  formReducer,
  widgetInitialState,
  widgetReducer
} from './reducers';
import type { FormState } from './types';

const formStateRegistry = new Map<string | symbol, FormState>();

type FormProviderProps = PropsWithChildren<{
  widgetId: string | symbol;
}>;

export function FormProvider({ widgetId, children }: FormProviderProps) {
  const [state, dispatch] = useReducer(
    formReducer,
    undefined,
    () => formStateRegistry.get(widgetId) ?? createFormInitialState()
  );

  useEffect(() => {
    return () => {
      formStateRegistry.set(widgetId, state);
    };
  }, [widgetId, state]);

  return (
    <FormContext.Provider
      value={{
        state,
        dispatch
      }}
    >
      {children}
    </FormContext.Provider>
  );
}

export function WidgetProvider({ children }: PropsWithChildren) {
  const [state, dispatch] = useReducer(widgetReducer, widgetInitialState);

  return (
    <WidgetContext.Provider
      value={{
        state,
        dispatch
      }}
    >
      {children}
    </WidgetContext.Provider>
  );
}
